window.css = require('json-to-css');

window.styleElement = document.createElement("style");
window.styleElement.id = "customStyle";
window.styleElement.type = "text/css";

window.customStyle = {
    // Background
    ".content" : {
        "background-color": "white !important"
    },
    // Header
    "header" : {
        "background-color": "white !important",
        "height": "150px !important",
        "box-sizing": "content-box !important",
        "border": "none !important",
        "box-shadow": "none !important",
        "position": "relative",
        "z-index": "1"
    },
    // Logo
    ".logo": {
        "width": "auto !important",
        "height": "80% !important"
    },
    // Avatar
    ".bot-avatar" : {
        "width": "150px !important",
        "height": "auto !important"
    },
    "#bot-intro" : {
        "width": "150px !important",
        "height": "auto !important"
    },
    "#bot-neutral" : {
        "max-width": "150px !important",
        "height": "auto !important"
    },
    "#bot-emotion" : {
        "max-width": "150px !important",
        "height": "auto !important"
    },
    // Menu
    ".container-payloads": {
        "background-color": "#fff !important",
        "text-align": "left !important"
    },
    // Menu Headline
    "#payloads-headline": {
        "color": "black !important",
        "font-family": "sans-serif",
        "font-size": null
    },
    // Webchat Input
    ".webchat-input": {
        "border-radius": "0px !important",
        "border-color": "black !important",
        "display": "block",
        "background": "white !important",
        "border-top-left-radius": "0px !important",
        "border-top-right-radius" : "0px !important",
        "border-bottom-right-radius" : "0px !important",
        "border-bottom-left-radius" : "0px !important",
        "box-sizing": "content-box !important",
        "border": "1px solid black !important",
        "box-shadow": "none !important",
        "width": "99% !important",
        "height": null,
        "align-self": "flex-start !important"
    },
    ".webchat-input-message-input": {
        "color": "#000 !important"
    },
    ".webchat-input-message-input::-webkit-input-placeholder": {
        "color": "#000 !important",
        "opacity": "0.8 !important"
    },
    // Bubble - Bot
    ".regular-message.bot" : {
        "background": "white !important",
        "color" : "black !important",
        "border-top-left-radius": "16px !important",
        "border-top-right-radius" : "16px !important",
        "border-bottom-right-radius" : "16px !important",
        "border-bottom-left-radius" : "0px !important",
        "padding-top": "16px !important",
        "padding-bottom": "16px !important",
        "padding-left": "24px !important",
        "padding-right": "24px !important",
        "margin-top": "8px !important",
        "margin-bottom": "8px !important",
        "margin-left": "0px !important",
        "margin-right": "0px !important",
        "box-sizing": "content-box !important",
        "border": "none !important",
        "box-shadow": "rgb(151 124 156 / 10%) 0px 5px 9px 0px, rgb(203 195 212 / 10%) 0px 5px 16px 0px, rgb(216 212 221 / 10%) 0px 8px 20px 0px !important",
        "font-family": "sans-serif",
        "font-size": null
    },
    ".BorderBubble" : {
        "background": "white !important",
        "color" : "black !important",
        "border-top-left-radius": "16px !important",
        "border-top-right-radius" : "16px !important",
        "border-bottom-right-radius" : "16px !important",
        "border-bottom-left-radius" : "0px !important",
        "padding-top": "16px !important",
        "padding-bottom": "16px !important",
        "padding-left": "24px !important",
        "padding-right": "24px !important",
        "margin-top": "8px !important",
        "margin-bottom": "8px !important",
        "margin-left": "0px !important",
        "margin-right": "0px !important",
        "box-sizing": "content-box !important",
        "border": "none !important",
        "box-shadow": "rgb(151 124 156 / 10%) 0px 5px 9px 0px, rgb(203 195 212 / 10%) 0px 5px 16px 0px, rgb(216 212 221 / 10%) 0px 8px 20px 0px !important",
        "font-family": "sans-serif",
        "font-size": null
    },
    // Webchat Indicator
    ".webchat-typing-indicator": {
        "background": "white !important",
        "color" : "black !important",
        "border-top-left-radius": "16px !important",
        "border-top-right-radius" : "16px !important",
        "border-bottom-right-radius" : "16px !important",
        "border-bottom-left-radius" : "0px !important",
        "padding-top": "16px !important",
        "padding-bottom": "16px !important",
        "padding-left": "24px !important",
        "padding-right": "24px !important",
        "margin-top": "8px !important",
        "margin-bottom": "8px !important",
        "margin-left": "0px !important",
        "margin-right": "0px !important",
        "box-sizing": "content-box !important",
        "border": "none !important",
        "box-shadow": "rgb(151 124 156 / 10%) 0px 5px 9px 0px, rgb(203 195 212 / 10%) 0px 5px 16px 0px, rgb(216 212 221 / 10%) 0px 8px 20px 0px !important",
        "font-family": "sans-serif",
        "font-size": null
    },
    // Bubble - User
    ".regular-message.user" : {
        "background": "white !important",
        "color" : "black !important",
        "border-top-left-radius": "16px !important",
        "border-top-right-radius" : "16px !important",
        "border-bottom-right-radius" : "0px !important",
        "border-bottom-left-radius" : "16px !important",
        "padding-top": "16px !important",
        "padding-bottom": "16px !important",
        "padding-left": "24px !important",
        "padding-right": "24px !important",
        "margin-top": "8px !important",
        "margin-bottom": "8px !important",
        "margin-left": "0px !important",
        "margin-right": "0px !important",
        "box-sizing": "content-box !important",
        "border": "none !important",
        "box-shadow": "rgb(151 124 156 / 10%) 0px 5px 9px 0px, rgb(203 195 212 / 10%) 0px 5px 16px 0px, rgb(216 212 221 / 10%) 0px 8px 20px 0px !important",
        "font-family": "sans-serif",
        "font-size": null
    },
    // Quick Reply
    ".MessengerQuickReply" : {
        "background": "transparent !important",
        "color": "black !important",
        "border-radius": "40px !important",
        "border-top-left-radius": null,
        "border-top-right-radius" : null,
        "border-bottom-right-radius" : null,
        "border-bottom-left-radius" : null,
        "padding": "4px 16px !important",
        "padding-top": null,
        "padding-bottom": null,
        "padding-left": null,
        "padding-right": null,
        "margin": "5px !important",
        "margin-top": null,
        "margin-bottom": null,
        "margin-left": null,
        "margin-right": null,
        "box-sizing": null,
        "border": "1px solid black !important",
        "box-shadow": null,
        "font-family": "sans-serif",
        "font-size": "15px !important",
        "cursor": "pointer"
    },
    // Quick Reply Hover
    ".MessengerQuickReply:hover" : {
        "background": "transparent !important",
        "color": "black !important",
        "border-radius": "40px !important",
        "border-top-left-radius": null,
        "border-top-right-radius" : null,
        "border-bottom-right-radius" : null,
        "border-bottom-left-radius" : null,
        "padding": "4px 16px !important",
        "padding-top": null,
        "padding-bottom": null,
        "padding-left": null,
        "padding-right": null,
        "margin": "5px !important",
        "margin-top": null,
        "margin-bottom": null,
        "margin-left": null,
        "margin-right": null,
        "box-sizing": null,
        "border": "1px solid black !important",
        "box-shadow": null,
        "font-family": "sans-serif",
        "font-size": "15px !important",
        "cursor": "pointer"
    },
    // Link Button
    ".MessengerFrame": {
        "width" : "100% !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "border-radius": "0px !important"
    },
    ".MessengerText": {
        "padding": "16px 24px !important",
        "background": "white !important",
        "box-shadow": "rgb(151 124 156 / 10%) 0px 5px 9px 0px, rgb(203 195 212 / 10%) 0px 5px 16px 0px, rgb(216 212 221 / 10%) 0px 8px 20px 0px !important",
        "border-radius": "16px 16px 16px 0px !important",
        "border": "1px solid rgb(230, 230, 230) !important",
        "color" : "black !important",
        "border-top-left-radius": null,
        "border-top-right-radius" : null,
        "border-bottom-right-radius" : null,
        "border-bottom-left-radius" : null,
        "padding-top": null,
        "padding-bottom": null,
        "padding-left": null,
        "padding-right": null,
        "margin-top": "8px !important",
        "margin-bottom": "8px !important",
        "margin-left": null,
        "margin-right": null,
        "box-sizing": null,
        "font-family": "sans-serif",
        "font-size": null
    },
    ".MessengerButton": {
        "background": "white !important",
        "color": "black !important",
        "border-radius": "40px !important",
        "border-top-left-radius": null,
        "border-top-right-radius" : null,
        "border-bottom-right-radius" : null,
        "border-bottom-left-radius" : null,
        "padding-top": "10px !important",
        "padding-bottom": "10px !important",
        "padding-left": "20px !important",
        "padding-right": "20px !important",
        "margin": "5px !important",
        "margin-top": null,
        "margin-bottom": null,
        "margin-left": null,
        "margin-right": null,
        "box-sizing": null,
        "border": "1px solid black !important",
        "box-shadow": null,
        "font-family": "sans-serif",
        "font-size": null,
        "width": "fit-content !important",
        "display": "inline-block !important"
    },
    // Link Button Hover
    ".MessengerButton:hover": {
        "background": "white !important",
        "color": "black !important",
        "border-radius": "40px !important",
        "border-top-left-radius": null,
        "border-top-right-radius" : null,
        "border-bottom-right-radius" : null,
        "border-bottom-left-radius" : null,
        "padding-top": "10px !important",
        "padding-bottom": "10px !important",
        "padding-left": "20px !important",
        "padding-right": "20px !important",
        "margin": "5px !important",
        "margin-top": null,
        "margin-bottom": null,
        "margin-left": null,
        "margin-right": null,
        "box-sizing": null,
        "border": "1px solid black !important",
        "box-shadow": null,
        "font-family": "sans-serif",
        "font-size": null,
        "width": "fit-content !important",
        "display": "inline-block !important"
    },
    // Image and Video
    ".MessengerFrameMedia": {
        "width": "250px !important",
        "height": "auto !important",
        "margin-top": "8px !important",
        "margin-bottom": "8px !important",
        "margin-left": null,
        "margin-right": null,
        "border-top-left-radius": "16px !important",
        "border-top-right-radius" : "16px !important",
        "border-bottom-right-radius" : "16px !important",
        "border-bottom-left-radius" : "16px !important"
    },
    // Gallery
    ".cognigy-webchat-1mv2cde": {
        "background-color": "white !important"
    },
    ".cognigy-webchat-kifjyg": {
        "box-shadow": "none !important"
    },
    ".cognigy-webchat-orcf8t": {
        "border-bottom": "0px !important"
    },
    ".cognigy-webchat-12tlige": {
        "font-family": "sans-serif",
        "font-size": null,
        "color": null
    },
    ".cognigy-webchat-14qz9ku": {
        "font-family": "sans-serif",
        "font-size": null,
        "color": null
    }
};


window.styleElement.textContent = window.css.of(window.customStyle);
document.head.appendChild(window.styleElement);